import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useImperativeHandle } from 'react';
import { ImageUploader, Toast, Dialog, Mask } from 'antd-mobile';
import { CloseCircleOutline } from 'antd-mobile-icons';
// import Player from 'xgplayer';
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { v4 as uuidv4 } from 'uuid';
import { utils } from '../../index';
import './index.less';
const h = document.documentElement.clientHeight;
// const w = document.documentElement.clientWidth;
// 上传视频
const UploadVideo = (props) => {
    // size 单位MB
    const { maxCount = 5, size, list = [], cRef, uploadToken, width = 80, hideUpload = false } = props;
    const [fileList, setFileList] = useState(list);
    const [visible, setVisible] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');
    function beforeUpload(file) {
        if (size && file.size > utils.calcTimes([size, 1048576])) {
            Toast.show(`请选择小于 ${size}M 的文件`);
            return null;
        }
        return file;
    }
    async function uploadMethods(file) {
        const formData = new FormData();
        const nameArr = file?.name?.split('.');
        const name = nameArr[nameArr.length - 1];
        const key = uuidv4();
        formData.append('file', file);
        formData.append('token', uploadToken);
        formData.append("name", key + `.${name}`);
        formData.append('key', key + `.${name}`);
        return fetch('//upload.qiniup.com/', {
            method: 'POST',
            body: formData, //将formData 赋值给body即可
        })
            .then(response => response.json())
            .then(res => {
            if (res.url) {
                setFileList([...fileList, res]);
                return res;
            }
            else {
                if (res.code === 'token not specified') {
                    Toast.show(`上传token无效,请刷新重试`);
                }
                else {
                    Toast.show(`上传失败,请重新上传或刷新重新`);
                }
                return false;
            }
        })
            .catch(function (error) {
            console.log(error);
        });
    }
    // 父组件获取子组件内的数据   暴露给父组件的方法
    useImperativeHandle(cRef, () => ({
        getPictureList: () => {
            return fileList.filter((v) => v && v?.url);
        }
    }));
    const startPlayer = (item) => {
        setVisible(true);
        setVideoUrl(item.url);
        Toast.show({
            icon: 'loading',
        });
        setTimeout(() => {
            Toast.clear();
            const player = videojs('my-player', {}, () => {
                // onReady && onReady(player);
            });
            player?.play();
        }, 1000);
    };
    const deleteItem = (item) => {
        Dialog.confirm({
            content: '是否删除',
            onConfirm: () => {
                const arr = [];
                fileList.map((ele) => {
                    if (ele.url !== item.url)
                        arr.push(ele);
                });
                setFileList(arr);
            },
        });
    };
    //   http://source.ymq.me/o_1hare4vs915re1jas1sp3a6m12drg.mp4
    return (_jsxs("div", { className: 'video_upload_htui', children: [fileList.map((item) => {
                const { url } = item;
                return _jsxs("div", { className: 'file_htui', children: [_jsx("div", { className: 'file_htui_icon', onClick: () => deleteItem(item), children: _jsx(CloseCircleOutline, {}) }), _jsx("video", { onClick: () => startPlayer(item), className: 'img_htui', width: width, height: width, src: url })] }, url);
            }), _jsx(ImageUploader, { upload: uploadMethods, maxCount: maxCount, showUpload: hideUpload == null ? fileList.length < maxCount : !hideUpload, beforeUpload: beforeUpload, deletable: !hideUpload, showFailed: false, accept: '', style: { '--cell-size': `${width}px` } }), _jsx(Mask, { visible: visible, destroyOnClose: true, onMaskClick: () => setVisible(false), children: _jsx("div", { style: { height: h * 0.8 + 'px', width: '100vw', marginTop: h * 0.1 + 'px' }, children: _jsx("video", { id: "my-player", style: { height: '100%', width: '100vw' }, controls: true, preload: "auto", "data-setup": '{}', children: _jsx("source", { src: videoUrl, type: "video/mp4" }) }) }) })] }));
};
export default UploadVideo;
//# sourceMappingURL=video.js.map